export function getDeviceId(): string {
  const storageKey = 'inntea-device-id';

  let deviceId = localStorage.getItem(storageKey);

  if (!deviceId) {
    deviceId = generateDeviceFingerprint();
    localStorage.setItem(storageKey, deviceId);
  }

  return deviceId;
}

function generateDeviceFingerprint(): string {
  const components = [
    navigator.userAgent,
    navigator.language,
    screen.width,
    screen.height,
    screen.colorDepth,
    new Date().getTimezoneOffset(),
    navigator.hardwareConcurrency || 'unknown',
  ];

  const fingerprint = components.join('|');

  let hash = 0;
  for (let i = 0; i < fingerprint.length; i++) {
    const char = fingerprint.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash;
  }

  const random = Math.random().toString(36).substring(2, 15);

  return `${Math.abs(hash).toString(16)}-${random}-${Date.now().toString(36)}`;
}
